import { Td, Tr } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

export default function TableError({ message }: { message?: string }) {
  const { t } = useTranslation()

  return (
    <Tr>
      <Td colSpan={9999}>
        {message || t('general.common.exceptions.genericError')}
      </Td>
    </Tr>
  )
}
